export function trim(input: string): string {
	return input.trim();
}
